module.exports = __webpack_public_path__ + "img/location.16bd8912.svg";